//@flow
import axios from 'axios'
import {parse} from 'query-string'

export default (bodyAsQs: string) => {
  return axios.post(`/oauth2/cancel`, parse(bodyAsQs), {
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  })
}



// WEBPACK FOOTER //
// ./src/api/cancel.js